import React from "react";
import styled from "styled-components";

import { StyledGrid } from "components/simple";
import Button from "components/simple/Button";
import { spacingDefaults } from "style/constants";

const StyledLink = styled.a`
  text-decoration: none;
`;

const AppStoreButton = styled(Button)`
  && {
    height: 48px;
    padding: 0 16px;
  }
`;

interface BGCStoreLinkButtonProps {
  href: string;
  label: string;
  logo: string;
  logoAlt: string;
  logoSize: number;
}

const BGCStoreLinkButton: React.FC<BGCStoreLinkButtonProps> = ({
  href,
  label,
  logo,
  logoAlt,
  logoSize
}) => (
  <StyledLink href={href} rel="noopener noreferrer" target="_blank">
    <AppStoreButton>
      <StyledGrid
        container
        alignItems="center"
        style={{ gap: spacingDefaults.xsmall, whiteSpace: "nowrap" }}
      >
        <span>{label}</span>
        <img alt={logoAlt} height={logoSize} src={logo} width={logoSize} />
      </StyledGrid>
    </AppStoreButton>
  </StyledLink>
);

export default BGCStoreLinkButton;
